import React, { useEffect, useState } from 'react';
import DoctorInfoService from '../doctorInfo/doctorInfoService';
import OfficeService from '../office/officeService';
import ImageService from '../images/imageService';
import './DoctorDirectory.css';

const DoctorDirectory = () => {
  const [doctors, setDoctors] = useState([]);
  const [search, setSearch] = useState('');
  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const doctorsPerPage = 10;

  const doctorService = new DoctorInfoService();
  const officeService = new OfficeService();
 

  useEffect(() => {
    const fetchDoctors = async () => {
      try {
        const allDoctors = await doctorService.getAllDoctors();

        const filtered = allDoctors.filter(doc => {
          const specialty = doc.specialty?.toLowerCase() || '';
          return specialty.includes('physical therapist') || specialty.includes('massager');
        });

        const withOfficeNamesAndImages = await Promise.all(
          filtered.map(async (doc) => {
            const officeName = await officeService.getOfficeNameById(doc.officeId);
            const imagePath = `/images/doctor/${doc.username}/${doc.imageName || 'default.jpg'}`;
            return { ...doc, officeName, imageUrl: imagePath };
          })
        );

        setDoctors(withOfficeNamesAndImages);
      } catch (error) {
        console.error("Error loading doctor directory:", error.message);
      }
    };

    fetchDoctors();
  }, []);

  const filteredDoctors = doctors.filter(doc =>
    doc.firstName.toLowerCase().includes(search.toLowerCase()) ||
    doc.lastName.toLowerCase().includes(search.toLowerCase()) ||
    doc.specialty.toLowerCase().includes(search.toLowerCase()) ||
    doc.officeName.toLowerCase().includes(search.toLowerCase())
  );

  const indexOfLastDoctor = currentPage * doctorsPerPage;
  const indexOfFirstDoctor = indexOfLastDoctor - doctorsPerPage;
  const currentDoctors = filteredDoctors.slice(indexOfFirstDoctor, indexOfLastDoctor);
  const totalPages = Math.ceil(filteredDoctors.length / doctorsPerPage);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  return (
    <div className="doctor-directory">
      <h1>Meet Our Physical & Massage Therapists</h1>

      <input
        type="text"
        placeholder="Search by name, office or specialty"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        className="search-input"
      />

      <div className="doctor-list">
        {currentDoctors.map((doc, index) => (
          <div className="doctor-card" key={index} onClick={() => setSelectedDoctor(doc)}>
            <img
              src={doc.imageUrl}
              alt={`${doc.firstName} ${doc.lastName}`}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = '/images/doctor/default.jpg';
              }}
            />
            <h3>{doc.firstName} {doc.lastName}</h3>
            <p><strong>Specialty:</strong> {doc.specialty}</p>
            <p><strong>Office:</strong> {doc.officeName}</p>
          </div>
        ))}
      </div>

      {totalPages > 1 && (
        <div className="pagination">
          <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>Prev</button>
          <span>Page {currentPage} of {totalPages}</span>
          <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>Next</button>
        </div>
      )}

      {selectedDoctor && (
        <div className="doctor-popup" onClick={() => setSelectedDoctor(null)}>
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={() => setSelectedDoctor(null)}>&times;</button>
            <img
              src={selectedDoctor.imageUrl}
              alt={`${selectedDoctor.firstName} ${selectedDoctor.lastName}`}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = '/images/doctor/default.jpg';
              }}
            />
            <h2>{selectedDoctor.firstName} {selectedDoctor.lastName}</h2>
            <p><strong>Specialty:</strong> {selectedDoctor.specialty}</p>
            <p><strong>Office:</strong> {selectedDoctor.officeName}</p>
            <p className="bio">{selectedDoctor.bio}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default DoctorDirectory;
